/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IObstetricEvent } from 'app/shared/model/obstetric-event.model';
import { IPregnancyCase } from 'app/shared/model/pregnancy-case.model';
import { IAdmission } from 'app/shared/model/admission.model';
import { IReferral } from 'app/shared/model/referral.model';

export interface ILaborIncident {
  id?: string;
  validLabor?: boolean | null;
  active?: boolean | null;
  cursor?: number | null;
  lastUpdated?: number | null;
  microSec?: number | null;
  timestampEntry?: number | null;
  expose?: boolean | null;
  laborComplete?: boolean | null;
  laborCompleteTime?: number | null;
  obstetricEvent?: IObstetricEvent | null;
  pregnancy?: IPregnancyCase | null;
  admission?: IAdmission | null;
  referral?: IReferral | null;
}

export const defaultValue: Readonly<ILaborIncident> = {
  validLabor: false,
  active: false,
  expose: false,
  laborComplete: false,
};
